/* Farbverbrauchsrechner — Logik (Vanilla JS, defer-load).
   - Fläche als Slider 1–500 m² + gekoppeltes Zahlenfeld; LIVE-Update des Ergebnisses
   - Modus-Tabs (Innen/Fassade) für Hero-Swap + Default-Produkt
   - Maße-Helfer (Breite × Höhe − Abzüge)
   - Advanced-Akkordeon: Produkt-Picker (alle Produkte sichtbar, optgroup nach Modus)
     + Untergrund-Faktor + Sicherheitszuschlag
   - Math: liter = area × avgRate × coats × untergrund × (1 + margin/100)
           buckets = ceil(liter / bucket_size)
   - AJAX /cart/add.js mit Dawn-Pattern (sections=cart-drawer,cart-icon-bubble) +
     cartDrawer.renderContents(response) → korrektes Refresh + Auto-Open.
     CO2-Surcharge-Manager bleibt unangetastet (co2_variant-Attribut wird nicht überschrieben).
   - Chat-Handoff: öffnet shop-ai-assistant (#saa-fab) und füllt #saa-input.
   - Free-Shipping-Progress-Bar im Ergebnis (zeigt fehlende €-Differenz)
   - Mobile-Sticky-CTA via IntersectionObserver auf #fvr-add-to-cart
   - GA4 via track() — sendet BEIDES: dataLayer.push UND gtag('event',...). */
(function(){
  var root = document.getElementById('fvr');
  if (!root) return;
  var form = document.getElementById('fvr-form');
  if (!form) return;

  var modeRadios = form.querySelectorAll('input[name="fvr-mode"]');
  var coatsRadios = form.querySelectorAll('input[name="fvr-coats"]');
  var areaSlider = document.getElementById('fvr-area');
  var areaText = document.getElementById('fvr-area-text');
  var helperToggle = document.getElementById('fvr-toggle-helper');
  var helperPanel = document.getElementById('fvr-helper');
  var helperW = document.getElementById('fvr-h-w');
  var helperH = document.getElementById('fvr-h-h');
  var helperD = document.getElementById('fvr-h-d');
  var helperApply = document.getElementById('fvr-helper-apply');
  var advToggle = document.getElementById('fvr-toggle-advanced');
  var advPanel = document.getElementById('fvr-advanced');
  var productSelect = document.getElementById('fvr-product');
  var substrateSelect = document.getElementById('fvr-substrate');
  var marginInput = document.getElementById('fvr-margin');

  var resultEl = document.getElementById('fvr-result');
  var resultEmpty = resultEl.querySelector('.fvr__result-empty');
  var resultFilled = resultEl.querySelector('.fvr__result-filled');
  var resultLiters = document.getElementById('fvr-result-liters');
  var resultBuckets = document.getElementById('fvr-result-buckets');
  var resultPrice = document.getElementById('fvr-result-price');
  var resultShipping = document.getElementById('fvr-result-shipping');
  var resultLabel = document.getElementById('fvr-result-product-label');
  var resultPDP = document.getElementById('fvr-result-pdp');
  var resultFormula = document.getElementById('fvr-result-formula');
  var addBtn = document.getElementById('fvr-add-to-cart');
  var addSub = document.getElementById('fvr-add-sub');
  var askThomas = document.getElementById('fvr-ask-thomas');

  // Free-Shipping-Progress (neu) + Mobile-Sticky-CTA (neu)
  var shipProgress = document.getElementById('fvr-shipping-progress');
  var shipBarFill = document.getElementById('fvr-shipping-fill');
  var shipBarText = document.getElementById('fvr-shipping-text');
  var stickyCTA = document.getElementById('fvr-sticky-cta');
  var stickyBuckets = document.getElementById('fvr-sticky-buckets');
  var stickyPrice = document.getElementById('fvr-sticky-price');
  var stickyBtn = document.getElementById('fvr-sticky-btn');

  // M16 — dynamischer Ergebnis-CTA
  var collectionCTA = document.getElementById('fvr-collection-cta');
  var collectionLink = document.getElementById('fvr-collection-link');

  var SHIPPING_THRESHOLD = parseFloat(form.getAttribute('data-shipping-threshold')) || 149;
  var SLIDER_MIN = 1, SLIDER_MAX = 500;

  // ---- State ----
  var state = {
    mode: form.getAttribute('data-default-mode') || 'innen',
    coats: 2,
    area: parseInt(areaSlider.value, 10) || 50,
    substrate: 1.0,
    margin: 7,
    liters: 0,
    buckets: 0,
    estTotal: 0,
    hasPrice: false,
    selectedOption: null
  };

  // ---- Helpers ----
  function $$(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }
  function setHidden(el, hidden){ if (!el) return; if (hidden) el.setAttribute('hidden',''); else el.removeAttribute('hidden'); }
  function fmtNum(n, dec){ dec = dec==null?1:dec; return Number(n).toFixed(dec).replace('.', ','); }
  function fmtEUR(n){ return fmtNum(n, 0) + ' €'; }
  function clamp(n, lo, hi){ return Math.max(lo, Math.min(hi, n)); }

  // Tracking-Helper: feuert IMMER beides (dataLayer + gtag), damit die Events
  // garantiert in GA4 ankommen (egal ob GTM oder gtag.js direkt eingebunden ist).
  function track(eventName, params){
    params = params || {};
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({event: eventName}, params)); } catch(e){}
    try { if (typeof window.gtag === 'function') window.gtag('event', eventName, params); } catch(e){}
  }

  function getVisibleOption(){
    var sel = productSelect && productSelect.options[productSelect.selectedIndex];
    if (sel && !sel.hidden && !sel.disabled) return sel;
    return $$('option', productSelect).find(function(o){ return !o.hidden && !o.disabled; }) || null;
  }

  function ensureDefaultForMode(){
    var current = productSelect.options[productSelect.selectedIndex];
    if (current && current.getAttribute('data-mode') === state.mode) return;
    var fallback = $$('option', productSelect).find(function(o){
      return o.getAttribute('data-mode') === state.mode && o.getAttribute('data-tier') === 'standard';
    });
    if (fallback) productSelect.value = fallback.value;
  }

  function syncMode(){
    root.setAttribute('data-mode', state.mode);
    ensureDefaultForMode();
    $$('.fvr__hero-img', root).forEach(function(img){ img.classList.remove('is-active'); });
    var target = root.querySelector('.fvr__hero-img--' + state.mode);
    if (target) target.classList.add('is-active');
    Array.prototype.forEach.call(modeRadios, function(r){ r.checked = (r.value === state.mode); });
  }

  function setArea(v, syncBoth){
    v = parseInt(v, 10);
    if (isNaN(v)) v = state.area;
    v = clamp(v, SLIDER_MIN, 999);
    state.area = v;
    if (syncBoth !== 'slider') areaSlider.value = String(clamp(v, SLIDER_MIN, SLIDER_MAX));
    if (syncBoth !== 'text') areaText.value = String(v);
    var pct = ((clamp(v, SLIDER_MIN, SLIDER_MAX) - SLIDER_MIN) / (SLIDER_MAX - SLIDER_MIN)) * 100;
    areaSlider.style.setProperty('--fill', pct.toFixed(1) + '%');
  }

  // ---- M16 — dynamischer Ergebnis-CTA ----
  function updateCollectionCTA(){
    if (!collectionCTA || !collectionLink) return;
    var mode = state.mode;
    var modeKey = mode.charAt(0).toUpperCase() + mode.slice(1); // 'Innen' | 'Fassade'
    var url   = form.dataset['ctaUrl'   + modeKey] || '/collections/' + mode + 'farben';
    var label = form.dataset['ctaLabel' + modeKey] || 'Alle Farben ansehen →';
    collectionLink.href        = url;
    collectionLink.textContent = label;
    // CTA nur einblenden wenn Result-Panel bereits sichtbar
    if (resultFilled && !resultFilled.hasAttribute('hidden')){
      setHidden(collectionCTA, false);
    }
  }

  // ---- Math + Render ----
  function calculate(){
    var area = state.area;
    var opt = getVisibleOption();
    if (!opt) return;
    state.selectedOption = opt;

    var rateMin = parseFloat(opt.getAttribute('data-rate-min')) || 0.15;
    var rateMax = parseFloat(opt.getAttribute('data-rate-max')) || 0.18;
    var avgRate = (rateMin + rateMax) / 2;
    var bucket = parseFloat(opt.getAttribute('data-bucket')) || 15;
    var label = opt.getAttribute('data-label') || opt.textContent;
    var priceCents = parseInt(opt.getAttribute('data-price-cents'), 10);
    var hasPrice = Number.isFinite(priceCents) && priceCents > 0;
    var priceLabel = opt.getAttribute('data-price-label') || '';
    var canBuy = hasPrice && opt.getAttribute('data-available') === 'true' && !!opt.getAttribute('data-variant-id');
    var url = opt.getAttribute('data-url') || '#';

    var liters = area * avgRate * state.coats * state.substrate * (1 + state.margin/100);
    var buckets = Math.ceil(liters / bucket);
    state.liters = liters;
    state.buckets = buckets;

    var unitPrice = hasPrice ? priceCents / 100 : 0;
    var estTotal = buckets * (unitPrice || 0);
    state.estTotal = estTotal;
    state.hasPrice = hasPrice;

    resultEl.classList.remove('is-empty');
    setHidden(resultEmpty, true);
    setHidden(resultFilled, false);
    var shortLabel = label.split('·')[0].trim();
    resultLabel.textContent = shortLabel;
    resultLiters.textContent = fmtNum(liters, 1);
    resultBuckets.innerHTML = '<strong>' + buckets + ' × Eimer</strong> à ' + bucket + ' L';
    resultPrice.textContent = hasPrice ? ('Preis ' + priceLabel + ' pro Eimer · weiß' + (canBuy ? '' : ' · derzeit nicht verfügbar')) : 'Aktuellen Preis auf der Produktseite prüfen';

    // Free-Shipping-Block: entweder „Versandkostenfrei inklusive" (Pill, grün)
    // ODER „Progress + Noch X € zum kostenlosen Versand" (Bar)
    if (!canBuy){
      setHidden(resultShipping, true);
      setHidden(shipProgress, true);
    } else if (estTotal >= SHIPPING_THRESHOLD){
      setHidden(resultShipping, false);
      setHidden(shipProgress, true);
    } else {
      setHidden(resultShipping, true);
      setHidden(shipProgress, false);
      var remaining = SHIPPING_THRESHOLD - estTotal;
      var pct = clamp((estTotal / SHIPPING_THRESHOLD) * 100, 5, 100);
      if (shipBarFill) shipBarFill.style.width = pct.toFixed(1) + '%';
      if (shipBarText) shipBarText.textContent = 'Noch ' + fmtEUR(remaining) + ' zum kostenlosen Versand';
    }

    addBtn.disabled = !canBuy;
    if (stickyBtn) stickyBtn.disabled = !canBuy;
    addBtn.setAttribute('data-variant-id', opt.getAttribute('data-variant-id') || '');
    addBtn.setAttribute('data-quantity', String(buckets));
    addSub.textContent = buckets + '× ' + bucket + ' L';
    resultPDP.href = url;
    resultFormula.textContent = '= ' + fmtNum(area, 1) + ' m² × ' + fmtNum(avgRate, 3) + ' l/m² je Anstrich × ' + state.coats + ' Anstriche × ' + fmtNum(state.substrate, 2) + ' × ' + fmtNum(1 + state.margin/100, 2);

    // Sticky-CTA mit aktuellen Daten füllen
    if (stickyBuckets) stickyBuckets.textContent = buckets + '× ' + bucket + ' L · ' + shortLabel;
    if (stickyPrice) stickyPrice.textContent = canBuy ? ('~ ' + fmtEUR(estTotal)) : 'Verfügbarkeit auf der Produktseite prüfen';

    // M16 — dynamischer Ergebnis-CTA aktualisieren
    updateCollectionCTA();
  }

  var _gaTimer = null;
  function trackCalcDebounced(){
    if (_gaTimer) clearTimeout(_gaTimer);
    _gaTimer = setTimeout(function(){
      var opt = state.selectedOption;
      var params = {
        fvr_mode: state.mode,
        fvr_area: Math.round(state.area),
        fvr_coats: state.coats,
        fvr_liters: Math.round(state.liters),
        fvr_buckets: state.buckets,
        fvr_product: opt ? (opt.getAttribute('data-label') || '').split('·')[0].trim() : null
      };
      if (state.hasPrice) params.fvr_est_total_eur = Math.round(state.estTotal);
      track('fvr_calculate', params);
    }, 700);
  }

  // ---- Listeners ----
  Array.prototype.forEach.call(modeRadios, function(r){
    r.addEventListener('change', function(){
      if (r.checked){ state.mode = r.value; syncMode(); calculate(); trackCalcDebounced(); }
    });
  });
  Array.prototype.forEach.call(coatsRadios, function(r){
    r.addEventListener('change', function(){
      if (r.checked){ state.coats = parseInt(r.value, 10) || 2; calculate(); trackCalcDebounced(); }
    });
  });

  areaSlider.addEventListener('input', function(){
    setArea(areaSlider.value, 'slider'); calculate(); trackCalcDebounced();
  });
  areaText.addEventListener('input', function(){
    setArea(areaText.value, 'text'); calculate(); trackCalcDebounced();
  });

  if (helperToggle){
    helperToggle.addEventListener('click', function(){
      var open = helperToggle.getAttribute('aria-expanded') === 'true';
      helperToggle.setAttribute('aria-expanded', String(!open));
      setHidden(helperPanel, open);
      var txt = helperToggle.querySelector('.fvr__link-btn-text');
      if (txt) txt.textContent = open ? 'Maße eingeben statt Schieberegler' : 'Maße-Helfer schließen';
    });
  }
  if (helperApply){
    helperApply.addEventListener('click', function(){
      var w = parseFloat(helperW.value) || 0;
      var h = parseFloat(helperH.value) || 0;
      var d = parseFloat(helperD.value) || 0;
      var area = Math.max(0, Math.round(w * h - d));
      if (area > 0){ setArea(area); calculate(); trackCalcDebounced(); }
    });
  }
  if (advToggle){
    advToggle.addEventListener('click', function(){
      var open = advToggle.getAttribute('aria-expanded') === 'true';
      advToggle.setAttribute('aria-expanded', String(!open));
      setHidden(advPanel, open);
    });
  }

  if (productSelect){
    productSelect.addEventListener('change', function(){
      var opt = productSelect.options[productSelect.selectedIndex];
      if (opt){
        var optMode = opt.getAttribute('data-mode');
        if (optMode && optMode !== state.mode){
          state.mode = optMode; syncMode(); productSelect.value = opt.value;
        }
      }
      calculate(); trackCalcDebounced();
    });
  }
  if (substrateSelect){
    substrateSelect.addEventListener('change', function(){
      state.substrate = parseFloat(substrateSelect.value) || 1.0;
      calculate(); trackCalcDebounced();
    });
  }
  if (marginInput){
    marginInput.addEventListener('input', function(){
      var v = parseInt(marginInput.value, 10);
      state.margin = (isNaN(v) ? 7 : clamp(v, 0, 30));
      calculate(); trackCalcDebounced();
    });
    marginInput.addEventListener('change', function(){ marginInput.value = state.margin; });
  }

  // ---- Add to Cart — Dawn-Pattern (sections + renderContents) ----
  function performAddToCart(triggerEl){
    var variantId = addBtn.getAttribute('data-variant-id');
    var qty = parseInt(addBtn.getAttribute('data-quantity'), 10) || 1;
    if (!variantId){ window.location.href = resultPDP.href; return; }
    triggerEl = triggerEl || addBtn;
    triggerEl.classList.add('is-loading');
    addBtn.classList.add('is-loading');
    addBtn.classList.remove('is-success', 'is-error');

    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sectionsToRender = '';
    if (drawer && typeof drawer.getSectionsToRender === 'function'){
      try { sectionsToRender = drawer.getSectionsToRender().map(function(s){ return s.id; }).join(','); }
      catch(e){ sectionsToRender = 'cart-drawer,cart-icon-bubble'; }
    } else {
      sectionsToRender = 'cart-drawer,cart-icon-bubble';
    }

    var fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', String(qty));
    fd.append('sections', sectionsToRender);
    fd.append('sections_url', window.location.pathname);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json'},
      body: fd,
      credentials: 'same-origin'
    })
    .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, data:d}; }); })
    .then(function(res){
      addBtn.classList.remove('is-loading');
      triggerEl.classList.remove('is-loading');
      if (!res.ok || res.data.status){
        addBtn.classList.add('is-error');
        var lab = addBtn.querySelector('.fvr__btn-label');
        if (lab) lab.textContent = (res.data && res.data.description) ? 'Fehler — erneut?' : 'Fehler — bitte erneut';
        setTimeout(function(){
          addBtn.classList.remove('is-error');
          if (lab) lab.textContent = 'In den Warenkorb';
        }, 3000);
        return;
      }
      addBtn.classList.add('is-success');
      var lab2 = addBtn.querySelector('.fvr__btn-label');
      if (lab2) lab2.textContent = 'In den Warenkorb gelegt ✓';

      if (drawer && typeof drawer.renderContents === 'function'){
        try { drawer.renderContents(res.data); } catch(e){ console.warn('renderContents failed', e); }
      } else {
        setTimeout(function(){
          addBtn.classList.remove('is-success');
          if (lab2) lab2.textContent = 'In den Warenkorb';
        }, 2500);
      }

      track('fvr_add_to_cart', {
        fvr_variant_id: variantId,
        fvr_quantity: qty,
        fvr_liters_needed: Math.round(state.liters),
        fvr_mode: state.mode,
        value: Math.round(state.estTotal),
        currency: 'EUR'
      });

      setTimeout(function(){
        addBtn.classList.remove('is-success');
        if (lab2) lab2.textContent = 'In den Warenkorb';
      }, 3500);
    })
    .catch(function(){
      addBtn.classList.remove('is-loading');
      triggerEl.classList.remove('is-loading');
      addBtn.classList.add('is-error');
      var lab3 = addBtn.querySelector('.fvr__btn-label');
      if (lab3) lab3.textContent = 'Verbindungsfehler';
      setTimeout(function(){
        addBtn.classList.remove('is-error');
        if (lab3) lab3.textContent = 'In den Warenkorb';
      }, 3000);
    });
  }
  addBtn.addEventListener('click', function(){ performAddToCart(addBtn); });
  if (stickyBtn) stickyBtn.addEventListener('click', function(){ performAddToCart(stickyBtn); });

  // M16 — GA4 select_content bei Klick auf Ergebnis-CTA
  if (collectionLink){
    collectionLink.addEventListener('click', function(){
      track('select_content', {
        content_type: 'rechner_cta',
        item_id: state.mode
      });
    });
  }

  // ---- Chat-Handoff ----
  askThomas.addEventListener('click', function(){
    var opt = state.selectedOption || getVisibleOption();
    var label = opt ? (opt.getAttribute('data-label') || opt.textContent) : 'das Produkt';
    var ctx = 'Ich habe ' + (state.area ? state.area.toFixed(0) + ' m² ' : '')
      + (state.mode === 'fassade' ? 'Fassade' : 'Wand/Decke')
      + ', ' + state.coats + ' Anstriche, der Rechner sagt ca. '
      + state.liters.toFixed(1) + ' Liter ' + label.split('·')[0].trim()
      + ' (' + state.buckets + ' × Eimer). Passt das für meinen Untergrund — oder hast du noch eine Empfehlung?';

    var fab = document.getElementById('saa-fab');
    if (fab) fab.click();
    var tries = 0;
    function tryPrefill(){
      tries++;
      var inp = document.getElementById('saa-input');
      if (inp){
        inp.value = ctx;
        inp.dispatchEvent(new Event('input', {bubbles:true}));
        inp.focus();
        return;
      }
      if (tries < 30) setTimeout(tryPrefill, 200);
    }
    setTimeout(tryPrefill, 350);

    track('fvr_ask_thomas', {
      fvr_liters_needed: Math.round(state.liters),
      fvr_mode: state.mode
    });
  });

  // ---- Mobile-Sticky-CTA: einblenden wenn #fvr-add-to-cart aus dem Viewport raus ist ----
  if (stickyCTA && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        // Nur auf Mobile-Breite zeigen (sonst stört's)
        var isMobile = window.matchMedia && window.matchMedia('(max-width: 879px)').matches;
        if (!isMobile){ setHidden(stickyCTA, true); return; }
        // Wenn add-to-cart NICHT sichtbar UND Ergebnis schon befüllt → Sticky zeigen
        var resultFilledVisible = resultFilled && !resultFilled.hasAttribute('hidden');
        setHidden(stickyCTA, entry.isIntersecting || !resultFilledVisible);
      });
    }, {threshold: 0.01});
    io.observe(addBtn);
    // Bei Resize neu evaluieren
    window.addEventListener('resize', function(){
      if (!window.matchMedia('(max-width: 879px)').matches) setHidden(stickyCTA, true);
    });
  }

  // ---- Init ----
  syncMode();
  setArea(state.area);
  calculate();

  // GA4-Init-Tracking: ein Tool-View-Event, damit wir die Tool-Reichweite messen
  track('fvr_view', {fvr_mode: state.mode});
})();
